import moment from 'moment'
import { useSelector } from 'react-redux'
import useSWR from 'swr'

import type { EligibilityRequest, EligibleDiscount } from '@library/api-promotions'
import { eligibilityFetcher } from '@library/api-promotions'

import { getBasketDate } from 'selectors/basket'

type UseDeliveryDateDiscountArgs = {
  enabled: boolean
  boxType?: 'subscription' | 'transactional'
}

type EligibilityKey = EligibilityRequest & { scope: 'promotions-eligibility' }

const fetchEligibility = ({ scope: _scope, ...request }: EligibilityKey) =>
  eligibilityFetcher(request)

export const useDeliveryDateDiscount = ({
  enabled,
  boxType,
}: UseDeliveryDateDiscountArgs): EligibleDiscount | null => {
  const basketDate = useSelector(getBasketDate)

  const parsedDate = basketDate ? moment(basketDate) : null
  const deliveryDate = parsedDate?.isValid() ? parsedDate.format('YYYY-MM-DD') : ''

  const key: EligibilityKey | null =
    enabled && deliveryDate
      ? {
          scope: 'promotions-eligibility',
          delivery_date: deliveryDate,
          box_type: boxType,
        }
      : null

  const { data } = useSWR(key, fetchEligibility, { shouldRetryOnError: false })

  return data?.data?.eligible?.[0] ?? null
}
